import { useState, useEffect } from 'react'
import { detectClientLocale } from '~/utils/i18n.client'

export function useLocale() {
  const [locale, setLocale] = useState<string>('de')

  useEffect(() => {
    // Get current locale from cookie or detect it
    const currentLocale = detectClientLocale()
    setLocale(currentLocale)
  }, [])

  return locale
}
